import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@/services/api';

export const useTechnologyCreate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: any) => {
      const res = await request.post('/course-technology', data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['technology-list'] });
    }
  });
};

export const useTechnologyUpdate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: any }) => {
      const res = await request.patch(`/course-technology/${id}`, data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['technology-list'] });
    }
  });
};

export const useTechnologyDelete = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const res = await request.delete(`/course-technology/${id}`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['technology-list'] });
    }
  });
};

export const useCourseTechnologyCreate = useTechnologyCreate;
export const useCourseTechnologyUpdate = useTechnologyUpdate;
export const useCourseTechnologyDelete = useTechnologyDelete;
